import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {POST_NON_NATIONAL_GENERATE_RESULT} from '../../constants/apiUrls';
import {KeyValueResponse} from '../../api/model';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGenerateNonNationalResultFile = ({onSuccess, onError}: Input = {}) => {
  const postGenerateNonNationalResultFile = async (reqBody: KeyValueResponse) => {
    const res = await axiosClient.post(POST_NON_NATIONAL_GENERATE_RESULT, reqBody);

    return res.data;
  };

  return useCustomMutation(postGenerateNonNationalResultFile, {
    onSuccess,
    onError,
  });
};
